import * as types from './sampleActionTypes';

const initialState = {
  sampleList: [],
  sampleData: null,
  isLoading: false,
  error: null,
  addSampleData: null,
  updateSampleData: null,
  deleteSampleData: null,
  dropdownData: null,
  dropdownLoading: false,
  dropdownError: null,
  totalCount: 0,
  totalPages: 0,
  sampleColors: [],
  sampleColorsLoading: false,
  sampleColorsError: null,
  addSampleColorData: null,
  updateSampleColorData: null,
  deleteSampleColorData: null,
  createSampleWithColorsLoading: false,
  createSampleWithColorsData: null,
  createSampleWithColorsError: null,
  createWeaveFromSampleLoading: false,
  createWeaveFromSampleData: null,
  createWeaveFromSampleError: null,
};

export const sampleReducer = (state = initialState, action) => {
  switch (action.type) {
    // Get Sample
    case types.GET_SAMPLE_REQUEST:
      return { ...state, isLoading: true, error: null };
    case types.GET_SAMPLE_SUCCESS:
      return {
        ...state,
        isLoading: false,
        sampleList: action.payload?.SampleList || [],
        error: null
      };
    case types.GET_SAMPLE_ERROR:
      return { ...state, isLoading: false, error: action.payload };

    // Get Sample List with Filter
    case types.GET_SAMPLE_LIST_REQUEST:
      return { ...state, isLoading: true, error: null };
    case types.GET_SAMPLE_LIST_SUCCESS:
      return {
        ...state,
        isLoading: false,
        sampleList: action.payload?.SampleList || [],
        totalCount: action.payload?.TotalCount || 0,
        totalPages: action.payload?.TotalPages || 0,
        error: null
      };
    case types.GET_SAMPLE_LIST_ERROR:
      return { ...state, isLoading: false, error: action.payload };

    // Add Sample
    case types.ADD_SAMPLE_REQUEST:
      return { ...state, isLoading: true, error: null };
    case types.ADD_SAMPLE_SUCCESS:
      return { ...state, isLoading: false, addSampleData: action.payload, error: null };
    case types.ADD_SAMPLE_ERROR:
      return { ...state, isLoading: false, error: action.payload };

    // Update Sample
    case types.UPDATE_SAMPLE_REQUEST:
      return { ...state, isLoading: true, error: null };
    case types.UPDATE_SAMPLE_SUCCESS:
      return { ...state, isLoading: false, updateSampleData: action.payload, error: null };
    case types.UPDATE_SAMPLE_ERROR:
      return { ...state, isLoading: false, error: action.payload };

    // Delete Sample
    case types.DELETE_SAMPLE_REQUEST:
      return { ...state, isLoading: true, error: null };
    case types.DELETE_SAMPLE_SUCCESS:
      return { ...state, isLoading: false, deleteSampleData: action.payload, error: null };
    case types.DELETE_SAMPLE_ERROR:
      return { ...state, isLoading: false, error: action.payload };

    // Get Sample Dropdown
    case types.GET_SAMPLE_DROPDOWN_REQUEST:
      return { ...state, dropdownLoading: true, dropdownError: null };
    case types.GET_SAMPLE_DROPDOWN_SUCCESS:
      return {
        ...state, dropdownLoading: false, dropdownData:
          action.payload, dropdownError: null
      };
    case types.GET_SAMPLE_DROPDOWN_ERROR:
      return { ...state, dropdownLoading: false, dropdownError: action.payload };

    // Get Sample Colors
    case types.GET_SAMPLE_COLORS_REQUEST:
      return { ...state, sampleColorsLoading: true, sampleColorsError: null };
    case types.GET_SAMPLE_COLORS_SUCCESS:
      return {
        ...state,
        sampleColorsLoading: false,
        sampleColors: action.payload?.SampleColorList || [],
        sampleColorsError: null
      };
    case types.GET_SAMPLE_COLORS_ERROR:
      return { ...state, sampleColorsLoading: false, sampleColorsError: action.payload };

    // Add Sample Color
    case types.ADD_SAMPLE_COLOR_REQUEST:
      return { ...state, isLoading: true, error: null };
    case types.ADD_SAMPLE_COLOR_SUCCESS:
      return { ...state, isLoading: false, addSampleColorData: action.payload, error: null };
    case types.ADD_SAMPLE_COLOR_ERROR:
      return { ...state, isLoading: false, error: action.payload };

    // Update Sample Color
    case types.UPDATE_SAMPLE_COLOR_REQUEST:
      return { ...state, isLoading: true, error: null };
    case types.UPDATE_SAMPLE_COLOR_SUCCESS:
      return { ...state, isLoading: false, updateSampleColorData: action.payload, error: null };
    case types.UPDATE_SAMPLE_COLOR_ERROR:
      return { ...state, isLoading: false, error: action.payload };

    // Delete Sample Color
    case types.DELETE_SAMPLE_COLOR_REQUEST:
      return { ...state, isLoading: true, error: null };
    case types.DELETE_SAMPLE_COLOR_SUCCESS:
      return { ...state, isLoading: false, deleteSampleColorData: action.payload, error: null };
    case types.DELETE_SAMPLE_COLOR_ERROR:
      return { ...state, isLoading: false, error: action.payload };

    // Create Sample with Colors (composite)
    case types.CREATE_SAMPLE_WITH_COLORS_REQUEST:
      return { ...state, createSampleWithColorsLoading: true, createSampleWithColorsError: null };
    case types.CREATE_SAMPLE_WITH_COLORS_SUCCESS:
      return {
        ...state, createSampleWithColorsLoading: false,
        createSampleWithColorsData: action.payload, createSampleWithColorsError: null
      };
    case types.CREATE_SAMPLE_WITH_COLORS_ERROR:
      return {
        ...state, createSampleWithColorsLoading: false,
        createSampleWithColorsError: action.payload
      };

    // Create Weave from Sample
    case types.CREATE_WEAVE_FROM_SAMPLE_REQUEST:
      return { ...state, createWeaveFromSampleLoading: true, createWeaveFromSampleError: null };
    case types.CREATE_WEAVE_FROM_SAMPLE_SUCCESS:
      return {
        ...state, createWeaveFromSampleLoading: false,
        createWeaveFromSampleData: action.payload, createWeaveFromSampleError: null
      };
    case types.CREATE_WEAVE_FROM_SAMPLE_ERROR:
      return {
        ...state, createWeaveFromSampleLoading: false,
        createWeaveFromSampleError: action.payload
      };

    default:
      return state;
  }
};
